import { CommonModule } from '@angular/common';
import { Component, input, output } from '@angular/core';

@Component({
  selector: 'app-course-video',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './course-video.component.html',
  styleUrl: './course-video.component.scss',
})
export class CourseVideoComponent {
  videoUrl = input<string>('');
  posterUrl = input<string>('');

  /** Emitted when the video has finished playing */
  videoEnded = output<void>();

  onVideoEnded(): void {
    this.videoEnded.emit();
  }
}
